// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async fetchGetNotificationsByRecipient(ctx){
        const access_token = ctx.rootGetters.access_token;
        const id = localStorage.getItem('userId')
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/notifications/get-notifications-by-recipient/${id}`, config);
            ctx.commit('updateNotificationList', response.data.notifications) ;
        } catch (error) {
            return error;
        }
    },
};
